import './PlanTab.less';
export { default as PlanTab } from './PlanTab.js';
export { default } from './PlanTab.js';